module.exports = __webpack_public_path__ + "static/img/linda_cry.60ecb33.png";